<div class="navbar-top">
    <div class="logo">
        <img class="logo-icon" src="assets/images/logos/SSSS.svg">
        <span class="logo-text secondary-text" style="color: white;">{{app}} <br> <small>v.{{version}} | {{status}}</small></span>
    </div>

    <div class="buttons">
        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text" style="color: white;">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text" style="color: white;">arrow_back</mat-icon>
        </button>
    </div>
</div>

<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column">
        <div class="h3 username">{{userInfo?.name}}</div>
        <div class="h5 email hint-text mt-8">{{cabangInfo?.comloc_nama}}</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar"
                [src]="userInfo?.foto == null || userInfo?.foto == '' ? 'assets/images/avatars/profile.jpg' : userInfo?.foto">
            <!-- <img class="avatar" src="assets/images/avatars/Velazquez.jpg"> -->
        </div>
    </div>
    <br>
    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>
</div>

<!-- OPR_Future -->
<!-- <div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
    <div class="logo">
        <img class="logo-icon" src="assets/images/logos/fuse.svg">
        <img class="logo-icon" src="assets/images/logos/SSSS.svg">
        <span class="logo-text secondary-text">{{app}} <br> <small>v.{{version}}</small></span>
    </div>

    <div class="buttons">
        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>
    </div>
</div>

<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
        <div class="h3 username">{{userInfo.name}}</div>
        <div class="h5 email hint-text mt-8">{{cabangInfo.comloc_nama}}</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="assets/images/avatars/Velazquez.jpg">
        </div>
    </div>
    <br>
    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>
</div> -->